import { ajax } from '../../../services/helper'
class ApiService {

    getCostCentersData = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/costCenters/list"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    addCostCenters = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/costCenters/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    getCostCentersById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/costCenters/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     editCostCenters = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/costCenters/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    

    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Cost Centers/services/apiservices.js